export class GameLoop {
  private fps: number;
  private targetDelta: number;
  private lastTime: number = 0;
  private accumulator: number = 0;
  private animationFrameId: number | null = null;
  private isRunning: boolean = false;
  private updateCallback: () => void;
  private renderCallback: () => void;

  constructor(options: { fps: number; update: () => void; render: () => void }) {
    this.fps = options.fps;
    this.targetDelta = 1000 / this.fps;
    this.updateCallback = options.update;
    this.renderCallback = options.render;
  }

  private loop = (currentTime: number) => {
    if (!this.isRunning) return;

    const deltaTime = currentTime - this.lastTime;
    this.lastTime = currentTime;
    this.accumulator += deltaTime;

    // Fixed timestep updates
    while (this.accumulator >= this.targetDelta) {
      this.updateCallback();
      this.accumulator -= this.targetDelta;
    }

    this.renderCallback();
    this.animationFrameId = requestAnimationFrame(this.loop);
  };

  start() {
    if (this.isRunning) return;
    this.isRunning = true;
    this.lastTime = performance.now();
    this.accumulator = 0;
    this.animationFrameId = requestAnimationFrame(this.loop);
  }

  stop() {
    this.isRunning = false;
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  clear() {
    this.stop()
    this.updateCallback = () => {}
    this.renderCallback = () => {}
  }
}